import React from 'react';
import BaseLayout from './base.js';
import Testimonial from '../testimonial.js';

import {Arrow} from '../templates/elements.js';
import * as u from '../utils.js'

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "../css/slider.css";

/*---------------------------------------------*/

// custom animations - https://stackoverflow.com/questions/34600544/slick-carousel-easing-examples

/*---------------------------------------------*/

export default class SliderLayout extends BaseLayout {
	constructor(props) {
		super(props);

		this.slider = null;
		this.currentIndex = 0;

		this.next = this.next.bind(this);
		this.prev = this.prev.bind(this);
	}

	next() {
		this.slider.slickNext();
		window.ga && window.ga('send','event','navigation','slider','slide-next');
	}

	prev() {
		this.slider.slickPrev();
		window.ga && window.ga('send','event','navigation','slider','slide-prev');
	}

	getArrows(styles) {
		let arrowLeft = null;
		let arrowRight = null;

		if (!this.context.get('layout.slider.arrows.enabled',false,false))
			return {arrowLeft,arrowRight};


		let size = this.context.get('layout.slider.arrows.size',18);
		let arrowsSettings = {
			type: this.context.get('layout.slider.arrows.type','sharp'),
			container: this.context.get('layout.slider.arrows.container'),
			color: this.context.get('layout.slider.arrows.color','black'),
			background: this.context.get('layout.slider.arrows.background'),
			size: size
		}

		arrowsSettings.width = size*2;
		arrowsSettings.height = arrowsSettings.container === 'vrectangle' ? size*3-4 : size*2;
		
		styles.arrows.left = {
			...styles.arrows.common, 
			left: styles.container.paddingLeft/2,
			transform: 'translateY(-50%)'
		};

		styles.arrows.right = {...styles.arrows.common, 
			right: styles.container.paddingRight/2,
			transform: 'translateY(-50%)'
		};

		let arrowContainerSize = arrowsSettings.size*2;
		styles.container.paddingLeft += arrowContainerSize;
		styles.container.paddingRight += arrowContainerSize;
		
		arrowLeft = <Arrow {...arrowsSettings} dir="left" baseStyle={styles.arrows.left} onClick={this.prev}></Arrow>;
		arrowRight = <Arrow {...arrowsSettings} dir="right" baseStyle={styles.arrows.right} onClick={this.next}></Arrow>;

		return {arrowLeft,arrowRight};
	}

	render() {
		let items = this.props.items;
		let columns = 1*this.context.get('layout.cols',1,1);
		let itemsPerSlide = Math.min(columns, items.length);
		let maxSlides = this.context.get('layout.slider.maxSlides',this.context.default('layout.slider.maxSlides'));
		let dotsVisible = this.context.get('layout.slider.paging.enabled') && (items.length > itemsPerSlide);
		
		let spacing = this.context.get('layout.spacing');
		let paddingLeftRight = this.context.get('layout.padding.leftright',40,24);
		let paddingTopBottom = this.context.get('layout.padding.topbottom',40,24);
		let pagingDistance = this.context.get('layout.slider.paging.distance',24);
		let pagingDotSize = this.context.get('layout.slider.paging.dots.size',10);
		let pagingDotPadding = pagingDotSize / 2;
		let pagingDotColor = u.renderColor(this.context.get('layout.slider.paging.dots.color'));
		let pagingHeight = pagingDistance + pagingDotSize;
		let pagingPaddingTopBottom = (pagingHeight+paddingTopBottom-pagingDotPadding*2)/2;

		let styles = {
			container: {
				position: 'relative',
				paddingLeft: paddingLeftRight,
				paddingRight: paddingLeftRight,
				paddingTop: paddingTopBottom,
				paddingBottom: dotsVisible ? 0 : paddingTopBottom,
				overflow: 'hidden'
			},
			testimonial: {
				width: '100%'
			},
			sliderSizerContainer: {
				whiteSpace: 'nowrap'
			},
			sliderSizer: {
				margin: -1*spacing/2
			},
			slides: {
				position: 'relative',
				padding: '0 40px',
				textAlign: 'left'
			},
			slide: {
				whiteSpace: 'noWrap',
				width: '100%'
			},
			pagination: {
				list: {
					width: '100%',
					margin: 0,
					padding: `${pagingPaddingTopBottom}px 0`,
					transform: `translateY(-${spacing/2}px)`,
					fontSize: 0,
					textAlign: 'center',
					boxSizing: 'border-box',
					whiteSpace: 'normal',
					lineHeight: `${pagingDotSize + pagingDotPadding*2}px`
				},
				dot: {
					background: pagingDotColor,
					border: 'none',
					borderRadius: 100,
					padding: 0,
					width: pagingDotSize,
					height: pagingDotSize,
					marginLeft: pagingDotSize/2,
					marginRight: pagingDotSize/2,
					cursor: 'pointer',
					opacity: 0.3,
					transition: 'opacity .2s, transform .2s',
					outline: 'none',
					verticalAlign: 'middle'
				}
			},
			arrows: {
				common: {
					position: 'absolute',
					top: `calc(50% - ${pagingHeight/2}px)`,
					cursor: 'pointer'
				}
			}
		}

		items = items.slice(0,itemsPerSlide*maxSlides);

		let slides = items.slice(0,itemsPerSlide*maxSlides);
		slides = slides.map((item,i) => <Testimonial data={item} key={i} baseStyle={styles.testimonial} page={1} alignGroup={100} />)

		let crossfade = this.context.get('layout.slider.transition') === 'crossfade';
		if (crossfade) {
			// bugfix https://github.com/akiran/react-slick/issues/705
			styles.testimonial.width = `${100/itemsPerSlide}%`;
			
			let slideCount = Math.ceil(items.length / itemsPerSlide);
			slides = Array(slideCount).fill(null).map((v,i) => <div key={i}>{slides.slice(itemsPerSlide*i, itemsPerSlide*(i+1))}</div>);
		}

		// https://react-slick.neostack.com/docs/api/
		let settings = {
			fade: crossfade,
			arrows: false,
			slidesToShow: itemsPerSlide,
			slidesToScroll: crossfade ? 1 : itemsPerSlide,
			speed: this.context.get('layout.slider.speed',500),
			beforeChange: (current, next) => this.currentIndex = next/settings.slidesToScroll,
			dots: dotsVisible,
			dotsClass: "pagination",
			appendDots: dots => <ul style={styles.pagination.list}>{dots}</ul>,
			customPaging: (i) => {
				let style = {...styles.pagination.dot};
				if (i === this.currentIndex)
					style.opacity = 1;

				return <button style={style}></button>;
			},

			autoplay: this.context.get('layout.slider.autoplay.enabled'),
			infinite: this.context.get('layout.slider.autoplay.infinite',true),
			autoplaySpeed: this.context.get('layout.slider.autoplay.speed',30)*1000,
			pauseOnHover: this.context.get('layout.slider.autoplay.pause'),
			pauseOnDotsHover: this.context.get('layout.slider.autoplay.pause')
		};

		let {arrowLeft,arrowRight} = this.getArrows(styles);

		return (
			<div className="slider" style={styles.container} ref={this.container}>
				{arrowLeft}
				<div style={styles.sliderSizerContainer}>
					<div style={styles.sliderSizer}>
						<Slider {...settings} ref={c => (this.slider = c)}>
							{slides}
						</Slider>
					</div>
				</div>
				{arrowRight}
			</div>
		)
	}
}

/*---------------------------------------------*/
/*---------------------------------------------*/